(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-catalog"]) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-dc-grid]');
    const cards = [...grid.children];
    const buttons = [...root.querySelectorAll('[data-kind]')].filter(el => el.tagName === 'BUTTON');
    const sort = root.querySelector('[data-dc-sort]');
    let kind = root.dataset.defaultKind || 'all';
    function update() {
      const priority = card => card.dataset.omega === (kind === 'bundle' ? 'bundle' : 'single') ? 0 : 1;
      const ordered = [...cards].sort((a,b) => priority(a) - priority(b) || (sort.value === 'price-up' ? +a.dataset.price - +b.dataset.price : sort.value === 'price-down' ? +b.dataset.price - +a.dataset.price : sort.value === 'name' ? a.dataset.title.localeCompare(b.dataset.title,'pl') : +a.dataset.index - +b.dataset.index));
      let count = 0;
      ordered.forEach(card => { card.hidden = kind !== 'all' && card.dataset.kind !== kind; if (!card.hidden) count++; grid.append(card); });
      const status = root.querySelector('[data-dc-count]');
      status.textContent = status.dataset.label + ' ' + count;
      root.querySelector('[data-dc-empty]').hidden = count > 0;
    }
    buttons.forEach(button => button.addEventListener('click', () => { kind = button.dataset.kind; buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button))); update(); }));
    sort.addEventListener('change', update);
    update();
    root.querySelector('[data-dc-tools]').hidden = false;
  }
  document.querySelectorAll('[data-dm-catalog]').forEach(setup);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-dm-catalog]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-hp-guide"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('[data-dm-guide]').forEach(root=>{if(root.dataset.guideReady)return;root.dataset.guideReady='true';const tabs=[...root.querySelectorAll('[role="tab"]')];const select=tab=>{tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1});root.querySelectorAll('[role="tabpanel"]').forEach(p=>{p.hidden=p.id!==tab.getAttribute('aria-controls')})};tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n]);tabs[n].focus()}})})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-omega-ritual"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.dm-ritual-photo--video').forEach(box=>{const video=box.querySelector('video'),button=box.querySelector('.dm-video-toggle');if(!video||!button)return;let manuallyPaused=false;const sync=()=>{const playing=!video.paused;box.classList.toggle('dm-video-is-playing',playing);button.setAttribute('aria-label',playing?'Zatrzymaj film':'Odtwórz film');button.setAttribute('aria-pressed',String(playing));};video.addEventListener('playing',()=>{box.classList.add('dm-video-has-played');sync();});video.addEventListener('pause',sync);button.addEventListener('click',()=>{if(video.paused){manuallyPaused=false;video.play().catch(()=>{});}else{manuallyPaused=true;video.pause();}});if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting&&!manuallyPaused)video.play().catch(()=>{});else video.pause();}),{threshold:.35}).observe(video);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
if (!customElements.get('dm-article-reading')) {
  customElements.define('dm-article-reading', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const content = this.querySelector('.article__content');
      const toc = this.querySelector('.dm-article-toc');
      if (!content || !toc) return;
      this.ready = true;
      this.abort = new AbortController();
      const headings = [...content.querySelectorAll('h2')].filter(h => h.textContent.trim());
      content.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('dm-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'dm-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || this.dataset.tableLabel);
        table.before(wrapper);
        wrapper.append(table);
      });
      const first = content.firstElementChild;
      if (first?.tagName === 'P' && /^Redakcja Dermash(?: Cosmetics)?\s*·\s*\d{1,2}\s+\S+\s+\d{4}\s*$/.test(first.textContent.trim())) first.remove();
      if (headings.length < 2) return;
      const list = toc.querySelector('ol');
      const links = headings.map((heading, index) => {
        if (!heading.id) heading.id = this.id + '-section-' + (index + 1);
        heading.tabIndex = -1;
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.textContent = heading.textContent.trim();
        link.href = window.location.href.split('#')[0] + '#' + encodeURIComponent(heading.id);
        link.addEventListener('click', () => heading.focus({preventScroll:true}), {signal:this.abort.signal});
        li.append(link);
        list.append(li);
        return link;
      });
      toc.hidden = false;
      this.classList.remove('dm-article-reading--plain');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.find(entry => entry.isIntersecting);
          if (!visible) return;
          links.forEach((link, index) => {
            if (headings[index] === visible.target) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }, {rootMargin:'-15% 0px -65% 0px'});
        headings.forEach(heading => this.observer.observe(heading));
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.ready = false;
      this.querySelector('.dm-article-toc ol')?.replaceChildren();
    }
  });
}

if (!customElements.get('dm-article-products')) {
  customElements.define('dm-article-products', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.dm-article-products__rail');
      this.controls = this.querySelector('.dm-article-products__controls');
      this.previous = this.querySelector('[data-dm-previous]');
      this.next = this.querySelector('[data-dm-next]');
      if (!this.rail || this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.update = () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        this.controls.hidden = max < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= max - 2;
      };
      const move = (direction) => {
        const card = this.rail.querySelector('li');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
        this.rail.scrollBy({left: direction * rtl * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.rail.addEventListener('scroll', this.update, {...options, passive:true});
      this.rail.addEventListener('keydown', (event) => {
        if (event.target !== this.rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.rail);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-dm-journal]').forEach(root => {
      if (root.dataset.ready) return;
      const filters = [...root.querySelectorAll('[data-dmj-filter]')];
      const rows = [...root.querySelectorAll('[data-dmj-row]')];
      const featured = root.querySelector('[data-dmj-featured]');
      const more = root.querySelector('[data-dmj-more]');
      const all = root.querySelector('[data-dmj-all]');
      const empty = root.querySelector('[data-dmj-empty]');
      const status = root.querySelector('[data-dmj-status]');
      const heading = root.querySelector('[data-dmj-heading]');
      const defaultHeading = heading.textContent;
      const hasFeatured = !!featured;
      let category = 'all';
      let expanded = false;
      let limit = 3;
      const update = (announce = true) => {
        const showFeatured = hasFeatured && category === 'all' && !expanded;
        if (featured) featured.hidden = !showFeatured;
        const matches = rows.filter(row => category === 'all' || row.dataset.category === category);
        const candidates = matches.filter(row => !showFeatured || row.dataset.featured !== 'true');
        rows.forEach(row => { row.hidden = true; });
        candidates.slice(0, limit).forEach(row => { row.hidden = false; });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dmjFilter === category)));
        heading.textContent = category === 'all' ? defaultHeading : filters.find(button => button.dataset.dmjFilter === category).textContent;
        more.hidden = candidates.length <= limit;
        empty.hidden = matches.length !== 0;
        if (announce) status.textContent = root.dataset.resultsLabel.replace('[count]', String(matches.length));
      };
      filters.forEach(button => button.addEventListener('click', () => {
        category = button.dataset.dmjFilter;
        expanded = false;
        limit = category === 'all' ? 3 : 6;
        update();
      }));
      more.addEventListener('click', () => {
        const oldVisible = rows.filter(row => !row.hidden);
        limit += 6;
        update();
        const firstNew = rows.find(row => !row.hidden && !oldVisible.includes(row));
        if (firstNew) firstNew.querySelector('a').focus({preventScroll: true});
      });
      all.addEventListener('click', event => {
        if (all.tagName === 'A' && !all.hasAttribute('data-expand-all')) return;
        event.preventDefault();
        category = 'all';
        expanded = true;
        limit = rows.length;
        update();
        heading.focus({preventScroll: true});
        heading.scrollIntoView({block: 'start'});
      });
      root.querySelector('[data-dmj-filters]').hidden = false;
      all.hidden = false;
      root.dataset.ready = 'true';
      update(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
